export default {
  profile: {
    updateProfile: 'Profile update',
    signup: 'Signup'
  }
}
